import type { RouteRecordRaw } from 'vue-router';
import AuthCallback from '@/pages/auth/callback/AuthCallback.vue';
import { DummyLayout } from '@/pages/_layout';

export const routeList: RouteRecordRaw[] = [
    {
        path: '/login',
        name: 'auth-callback',
        component: AuthCallback,
        meta: {
            title: '認証処理中',
            requiresAuth: false,
            requiresGuest: true,
            layout: DummyLayout,
        },
    },
];
